import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import Loading from "../Loading/Loading";
import Header from "../Header/Header";
import { Drawer } from "@material-ui/core";
import RightMenu from "../RightMenu";
import { DatePicker } from "jalali-react-datepicker";
import { now } from "moment-jalaali";
import UserListSelect from "./UserListSelect";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const UsersReports = (props) => {
    const [data, setDate] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies();
    const [startDate, setStartDate] = useState(
        Math.round(new Date().getTime() / 1000),
    );
    const [endDate, setEndDate] = useState(
        Math.round(new Date().getTime() / 1000),
    );
    const [users, setUsers] = useState(undefined);
    const [selectUsers, setSelectUsers] = useState([]);

    const [state, setState] = useState({ right: false });

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    function getUsers() {
        setLoading(true);
        const url = Constants.apiUrl + "/api/getHasRoleUsers";
        axios
            .get(url, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((r) => {
                setUsers(r.data);
                setLoading(false);
            })
            .catch((e) => {
                // if(e.response.status==403)
                // {
                //     window.location="403";
                // }
            });
    }

    function getLogs(startDate, endDate) {
        setLoading(true);
        const url = Constants.apiUrl + "/api/userReports";
        axios
            .post(
                url,
                {
                    startDate: startDate,
                    endDate: endDate,
                    // userIds: selectUsers,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                setDate(r.data);
                setLoading(false);
            })
            .catch((e) => {
                // if(e.response.status==403)
                // {
                //     window.location="403";
                // }
            });
    }
    const deleteByIndex = (index) => {
        setSelectUsers((oldValues) => {
            return oldValues.filter((_, i) => i !== index);
        });
    };

    const userChange = (e) => {
        if (e.target.checked) {
            let SU = selectUsers;
            SU.push(e.target.value);
            setSelectUsers(SU);
        } else {
            let SU = selectUsers;
            let y = SU.findIndex((id) => id === e.target.value);
            deleteByIndex(y);
        }
    };

    function searchLogs(e) {
        setLoading(true);
        getLogs(startDate, endDate);
    }

    useEffect(() => {
        getUsers();
    }, []);

    const endDateHandler = (value) => {
        let date = new Date(value).getTime() / 1000;
        setEndDate(date);
    };
    const startDateHandler = (value) => {
        let date = new Date(value).getTime() / 1000;
        setStartDate(date);
    };
    return (
        <React.Fragment>
            <Breadcrumb title={"گزارش عملکرد انبار"} />


            {loading && <Loading />}
            <div className="container-fluid border mt-4 p-3">



                <div className="row">
                    <div className="col-6  text-right">
                        <label>تاریخ پایان</label>

                        <DatePicker
                            className={["form-control"].join(" ")}
                            style={{ direction: "rtl" }}
                            timePicker={true}
                            value={endDate * 1000}
                            onClickSubmitButton={(value) => {
                                endDateHandler(value.value._d);
                            }}
                        />
                    </div>

                    <div className="col-6 text-right">
                        <label>تاریخ شروع</label>
                        <DatePicker
                            className={["form-control"].join(" ")}
                            style={{ direction: "rtl" }}
                            timePicker={true}
                            value={startDate * 1000}
                            onClickSubmitButton={(value) => {
                                startDateHandler(value.value._d);
                            }}
                        />
                    </div>
                </div>
                <div className="row my-4">
                    <button
                        className="btn btn-danger btn-block "
                        onClick={searchLogs}
                    >
                        جستجو
                    </button>
                </div>
            </div>

            <div className="my-5  table-responsive">
                <table className="table table-hover  ">
                    <thead className="">
                        <tr className="bg-primary text-white">
                            <td>کاربر</td>
                            <td>تعداد آیتم تولید شده</td>
                            <td>مجموع زمان تولید افعال</td>
                            <td>مجموع زمان تولید</td>
                            <td>تعداد محصول چیده شده</td>
                            <td>تعداد  چیده شده</td>
                            <td>تعداد بسته موجودی خورده</td>
                            <td>تعداد سفارش پیک شده</td>
                            <td>تعداد آیتم پیک شده</td>
                            <td>تعداد فاکتور بسته بندی شده</td>
                            <td>تعداد آیتم بسته بندی شده</td>
                            <td>تعداد آیتم فاکتور چک شده</td>
                        </tr>
                    </thead>
                    <tbody>
                        {data &&
                            data.response.map((item, index) => {
                                return (
                                    <tr>
                                        <td className="bg-primary text-white">
                                            {item.user}
                                        </td>
                                        <td className="text-muted">
                                            {item.production}
                                        </td>
                                        <td className="text-muted">
                                            {item.productionTimeVerb}
                                        </td>
                                        <td className="text-muted">
                                            {item.productionTime}
                                        </td>
                                        <td className="text-muted">
                                            {item.picked}
                                        </td>
                                        <td className="text-muted">
                                            {item.pickedCount}
                                        </td>
                                        <td className="text-muted">
                                            {item.packStock}
                                        </td>
                                        <td className="text-muted">
                                            {item.pickedFactor}
                                        </td>
                                        <td className="text-muted">
                                            {item.pickedFactorItem}
                                        </td>
                                        <td className="text-muted">
                                            {item.packedFactor}
                                        </td>
                                        <td className="text-muted">
                                            {item.packedFactorItem}
                                        </td>
                                        <td className="text-muted">
                                            {item.checkedFactor}
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>


            <div className="my-5  table-responsive">
                <table className="table table-hover  ">
                    <thead className="">
                        <tr className="bg-success text-white">
                            <td>کاربر</td>
                            <td>مجموع زمان تولید افعال</td>
                            <td>مجموع زمان تولید</td>
                            <td>تعداد محصول چیده شده</td>
                            <td>تعداد آیتم پیک شده</td>
                            <td>تعداد فاکتور بسته بندی شده</td>
                            <td>تعداد آیتم فاکتور چک شده</td>
                            <td>جمع کل</td>
                        </tr>
                    </thead>
                    <tbody>
                        {data &&
                            data.response.map((item, index) => {
                                return (
                                    <tr>
                                        <td className="bg-success text-white">
                                            {item.user}

                                        </td>

                                        <td className="text-muted">
                                            {item.productionTimeVerb}
                                        </td>
                                        <td className="text-muted">
                                            {item.productionTime}
                                        </td>
                                        <td className="text-muted">
                                            {Math.round(item.picked * data.chidan_score / 60)}
                                        </td>
                                        <td className="text-muted">
                                            {Math.round(item.pickedFactorItem * data.pick_score / 60)}
                                        </td>
                                        <td className="text-muted">
                                            {Math.round(item.packedFactor * data.pack_score / 60)}
                                        </td>
                                        <td className="text-muted">
                                            {Math.round(item.checkedFactor * data.check_score / 60)}
                                        </td>

                                        <td className="text-success">
                                            {Math.round(parseInt(
                                                parseInt(item.productionTime) +
                                                parseInt(item.picked * data.chidan_score / 60) +
                                                parseInt(item.pickedFactorItem * data.pick_score / 60) +
                                                parseInt(item.packedFactor * data.pack_score / 60) +
                                                parseInt(item.checkedFactor * data.check_score / 60)
                                            ))
                                            }
                                        </td>

                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
export default UsersReports;
